export const GRID_CENTER_LINE_COLOR = '#888888';
export const GRID_SIDE_LINE_COLOR = '#dddddd';
